/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import InViewComponent from '../../../shared/components/inView/inView';


/**
 * InnerBanner components is used to render component Inner Banner
 * @param {*} props 
 */
const InnerBanner = ({ banner_cta_button, banner_image, banner_info, banner_title, banner_disclaimer, tabChange }) => {
    const [inViewBanner, setInViewBanner] = useState(false);
    useEffect(() => {
        handleAnimation();
    }, [inViewBanner]);

    const handleAnimation = () => {
        const textHeading = document.getElementsByClassName("slide-left")[0];
        const svgIllustrated = document.getElementsByClassName("slide-right")[0];
        const disclaimer = document.getElementsByClassName("slide-left")[1];
        if (textHeading && svgIllustrated) {
            if (inViewBanner) {
                textHeading.classList.add("is-animate");
                svgIllustrated.classList.add("is-animate");
                disclaimer.classList.add("is-animate");
            } else {
                textHeading.classList.remove("is-animate");
                svgIllustrated.classList.remove("is-animate");
                disclaimer.classList.remove("is-animate");
            }
        }
    };
    return (
        <InViewComponent setInview={ (value) => {
            setInViewBanner(value);
        } }>
            <div className="innerBaneer">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 box-md-6 img-box">
                            <div className="customAnim slide-right">
                                <div className="inner-box">
                                    {
                                        banner_image &&
                                        <figure>
                                            <img src={ banner_image.url } alt="animated" />
                                            {/* <img src={ `${process.env.PUBLIC_URL}/images/illustrations/career_cover.svg` } alt="animated" /> */ }
                                        </figure>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="box-12 box-md-6 content-box">
                            <div className="customAnim slide-left">
                                <div className="inner-box">
                                    <div className="intro-box p-18">
                                        {
                                            banner_title &&
                                            <h1 className="heading has-line">{ banner_title }</h1>
                                        }
                                        {
                                            banner_info &&
                                            <div dangerouslySetInnerHTML={ { __html: banner_info } } />
                                        }
                                        <div className="button-box" >
                                            {
                                                banner_cta_button && !!banner_cta_button.length && banner_cta_button[0].cta_button && banner_cta_button.map((obj, index) => {
                                                    return (
                                                        <NavLink
                                                            key={ index }
                                                            aria-language={localStorage.getItem('languagePref')}
                                                            to={ `/pricing/#${index === 0 ? "personal-price" : "business-price"}` }
                                                            target={ obj.cta_button.target !== "" ? "_blank" : "_self" }
                                                            onClick={ () => tabChange(index === 0 ? "personal-price" : "business-price") }
                                                            className={ `button ${obj.button_type === "transparent" ? 'button-outline' : 'button-solid'} big-size` }>
                                                            { obj.cta_button.title }
                                                        </NavLink>
                                                    );
                                                })

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Disclaimer text with animation (order for flex items) */}
                        <div className="customAnim slide-left" style={{ order: 3 }}>
                            <div className="intro-box-disclaimer">
                            {
                                banner_disclaimer &&
                                <div dangerouslySetInnerHTML={ { __html: banner_disclaimer } } />
                            }
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </ InViewComponent>
    );
};


export default InnerBanner;